import React from 'react';
import AncillarySummary
    from "@CheckOrder/features/paymentSummary/features/ancillariesSummary/components/AncillarySummary";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

const AncillariesSummary = () => {
    const {
        selectedServices: {
            isBuyingPremiumSupport,
            isBuyingSMSNotification,
            isBuyingTier1FlexibleCancellation,
        },
        ticket: {
            ancillariesData: {
                premiumSupport: {
                    displayPrice: premiumSupportPrice,
                    displayCurrencySymbol: premiumSupportCurrency,
                },
                smsNotification: {
                    displayPrice: smsNotificationPrice,
                    displayCurrencySymbol: smsNotificationCurrency,
                },
                tier1FlexibleCancellation: {
                    displayPrice: tier1FlexibleCancellationPrice,
                    displayCurrencySymbol: tier1FlexibleCancellationCurrency,
                },
            },
        },
    } = useAppSelector((state) => (state.checkOrder))

    return (
        <>
            {isBuyingPremiumSupport && (
                <AncillarySummary
                    price={premiumSupportPrice}
                    currencySymbol={premiumSupportCurrency}
                    ancillaryNameKey="sys.premium_support"
                />
            )}
            {isBuyingSMSNotification && (
                <AncillarySummary
                    price={smsNotificationPrice}
                    currencySymbol={smsNotificationCurrency}
                    ancillaryNameKey="sys.sms_notification"
                />
            )}
            {isBuyingTier1FlexibleCancellation && (
                <AncillarySummary
                    price={tier1FlexibleCancellationPrice}
                    currencySymbol={tier1FlexibleCancellationCurrency}
                    ancillaryNameKey="sys.tier1_flexible_cancellation"
                />
            )}
        </>
    );
}

export default AncillariesSummary
